import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { ITalentList } from "../../../blocks/advancedsearch/src/SearchTalentController.web";

// Customizable Area Start
import React from "react";
import { Box } from "@mui/material";
import Loader from "../../../components/src/Loader.web";
import { scrollToTop } from "../../../components/src/utils";
import { navigateToUserProfile } from "../../../components/src/utils/userSlug.web";
import { logEvent } from "../../../components/src/utils/googleAnalytics/analyticsAdapter.web";

export enum FilterTypes {
  Skills = "Skills",
  Location = "Location",
  Gender = "Gender",
  AgeRange = "AgeRange",
  LanguageSpoken = "Language Spoken",
}

interface IFilterAndSortTags {
  type: "Sort" | "Filter";
  label: string;
  subLabel?: FilterTypes;
  value: string | string[];
}

export interface ITalent extends ITalentList {}

interface IUser {
  id: string;
  type: string;
  attributes: {
    activated: boolean;
    country_code: string | null;
    email: string;
    first_name: string;
    full_phone_number: string;
    last_name: string;
    type: string | null;
    status: string;
    role_id: number | null;
    roles: string;
    gender: string | null;
    full_name: string;
    user_image_url: string;
    age: number | null;
    date_of_birth: string | null;
    locations: string | null;
    languages: string[];
    created_at: string;
    updated_at: string;
    unique_auth_id: string;
  };
}

interface IUserListingSuccessResponse {
  accounts: {
    data: IUser[];
  };
  pagination: {
    current_page: number;
    next_page: number | null;
    total_count: number;
    total_pages: number;
    seed?: number;
  };
}

interface IUserListingErrorResponse {
  error: string;
}

interface IBannerContentSuccessResponse {
  data: [
    {
      id: string;
      type: string;
      attributes: {
        title: string;
        description: string;
        created_at: string;
        updated_at: string;
        image: string;
      };
    }
  ];
  meta: {
    message: string;
  };
}

interface IBannerContentErrorResponse {
  message: string;
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  arrayHolder: any;
  token: string;
  // Customizable Area Start
  usersList: IUser[];
  isLoading: boolean;
  isSearching: boolean;
  bannerImage: string;
  bannerHeading: string;
  bannerDescription: string;
  page: number;
  totalPages: number;
  randomSeed: number | null;
  rowsPerPage: number;
  showFilters: boolean;
  filterAndSortTags: IFilterAndSortTags[];
  searchUsersList: IUser[];
  searchValue: string;
  anchorEl: HTMLElement | null;
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class CatalogueController extends BlockComponent<Props, S, SS> {
  getProductApiCallId: any;
  bannerContentApiCallId: string = "";
  userListingApiCallId: string = "";
  searchUserListingApiCallId: string = "";
  timeoutId: number | null = null;
  searchFieldRef: React.RefObject<HTMLInputElement> = React.createRef();

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      // Customizable Area Start
      // Customizable Area End
    ];

    this.state = {
      arrayHolder: [],
      token: "",
      usersList: [],
      isLoading: false,
      isSearching: false,
      bannerImage: "",
      bannerHeading: "",
      bannerDescription: "",
      page: 0,
      totalPages: 0,
      randomSeed: null,
      rowsPerPage: 20,
      showFilters: false,
      filterAndSortTags: [],
      searchUsersList: [],
      searchValue: "",
      anchorEl: null,
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area Start
    // Customizable Area End
  }

  async componentDidMount() {
    super.componentDidMount();
    this.getToken();
    // Customizable Area Start
    if (this.isPlatformWeb() === false) {
      this.props.navigation.addListener("willFocus", () => {
        this.getToken();
      });
    }
    scrollToTop();
    this.getBannerDetailsApi();
    this.handleGetUsersList();
    // Customizable Area End
  }

  getToken = () => {
    const msg: Message = new Message(
      getName(MessageEnum.SessionRequestMessage)
    );
    this.send(msg);
  };

  getListRequest = (token: any) => {
    const header = {
      "Content-Type": configJSON.productApiContentType,
      token: token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getProductApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.productAPiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeGet
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  async receive(from: string, message: Message) {
    // Customizable Area Start
    runEngine.debugLog("Message Recived", message);
    if (getName(MessageEnum.SessionResponseMessage) === message.id) {
      let token = message.getData(getName(MessageEnum.SessionResponseToken));
      this.setState({ token: token });
    }

    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    const apiRequestCalId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    if (apiRequestCalId === this.userListingApiCallId) {
      this.handleUserListingApiResponse(responseJson);
    } else if (apiRequestCalId === this.searchUserListingApiCallId) {
      this.handleSearchUserListingApiResponse(responseJson);
    } else if (apiRequestCalId === this.bannerContentApiCallId) {
      this.handleBannerContentApiResponse(responseJson);
    }
    // Customizable Area End
  }

  // Customizable Area Start
  getSearchLoader = () => {
    return (
      <Box component="span" paddingX="10px">
        <Loader loading={this.state.isSearching} />
      </Box>
    );
  };

  convertFiltersToUrlParams = (filterAndSortTags: IFilterAndSortTags[]) => {
    const queryLabels: Record<string, string> = {
      [FilterTypes.Gender]: "gender",
      [FilterTypes.Location]: "locations",
      [FilterTypes.AgeRange]: "age_range",
      [FilterTypes.LanguageSpoken]: "language",
    };
    const params = new URLSearchParams();

    filterAndSortTags
      .filter((filter) => !filter.subLabel)
      .forEach(({ type, label, value }) => {
        const key = type === "Sort" ? "sort_by" : queryLabels[label];
        const sendValue = Array.isArray(value) ? value.join(",") : value;

        params.append(key, sendValue);
      });

    const convertedFilters = filterAndSortTags
      .filter((filter) => filter.subLabel)
      .reduce((acc, { subLabel = "", value }) => {
        acc[subLabel] = value;
        return acc;
      }, {} as Record<string, string | string[]>);

    if (Object.keys(convertedFilters).length > 0) {
      params.append("sub_categories", JSON.stringify(convertedFilters));
    }

    return params.toString();
  };

  handleGetUsersList = () => {
    const { page, randomSeed, rowsPerPage, filterAndSortTags } = this.state;
    let query = `pag=${page + 1}&per=${rowsPerPage}`;
    if (filterAndSortTags.length > 0) {
      const filtersAndSortQuery =
        this.convertFiltersToUrlParams(filterAndSortTags);
      query = `${query}&${filtersAndSortQuery}`;
    }

    if (!!randomSeed) {
      // Passing seed to get artists list in random order
      query = `${query}&seed=${randomSeed}`;
    }

    this.getUsersListApi(query);
  };

  onChangeHandler = (page: number) => {
    this.setState({ page }, () => this.handleGetUsersList());
    const mainElement = document.getElementsByClassName("catalogueHireTitle");
    if (mainElement.length > 0) {
      mainElement[0].scrollIntoView({ behavior: "smooth" });
    }
  };

  getUsersListApi = (query: string) => {
    this.setState({ isLoading: true });
    const endpoint = `${configJSON.userListingApiEndPoint}?${query}`;

    const header = {
      "Content-Type": configJSON.productApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.userListingApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeGet
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getSearchUsersListApi = (searchQuery: string) => {
    const { searchValue } = this.state
    logEvent('search', { search_term: searchValue })
    const apiEndpoint = `${configJSON.userListingApiEndPoint}?${searchQuery}`;

    const header = {
      "Content-Type": configJSON.productApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.searchUserListingApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      apiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeGet
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getBannerDetailsApi = () => {
    const header = {
      "Content-Type": configJSON.productApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.bannerContentApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.bannerContentApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeGet
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleUserListingApiResponse = (
    responseJson: IUserListingSuccessResponse | IUserListingErrorResponse
  ) => {
    if ("accounts" in responseJson) {
      const {
        accounts: { data },
        pagination: { seed, total_pages },
      } = responseJson;
      this.setState({
        usersList: data,
        randomSeed: seed || null,
        totalPages: total_pages,
        isLoading: false,
      });
    } else {
      this.setState({
        usersList: [],
        randomSeed: null,
        totalPages: 0,
        isLoading: false,
      });
    }
  };

  handleSearchUserListingApiResponse = (
    responseJson: IUserListingSuccessResponse | IUserListingErrorResponse
  ) => {
    if ("accounts" in responseJson) {
      const {
        accounts: { data },
      } = responseJson;
      this.setState({
        searchUsersList: data,
        isSearching: false,
      });
    } else {
      this.setState({ searchUsersList: [], isSearching: false });
    }
  };

  handleBannerContentApiResponse = (
    responseJson: IBannerContentSuccessResponse | IBannerContentErrorResponse
  ) => {
    if ("data" in responseJson && responseJson.data.length > 0) {
      const firstRecord = responseJson.data[0];
      const {
        attributes: { title, description, image },
      } = firstRecord;
      this.setState({
        bannerImage: image,
        bannerHeading: title,
        bannerDescription: description,
      });
    }
  };

  handleProfileRedirect = (userDetails: IUser) => {
    const {
      id,
      attributes: { first_name, last_name },
    } = userDetails;
    navigateToUserProfile(this.props.navigation, {
      id,
      firstName: first_name,
      lastName: last_name,
    });
  };

  handleChatRedirect = (userId: string) => {
    const message = new Message(getName(MessageEnum.NavigationMessage));
    message.addData(getName(MessageEnum.NavigationTargetMessage), "Chat");

    message.addData(getName(MessageEnum.NavigationPropsMessage), this.props);

    const raiseMessage: Message = new Message(
      getName(MessageEnum.NavigationPayLoadMessage)
    );
    raiseMessage.addData(getName(MessageEnum.SessionResponseData), {
      userUID: userId,
    });
    message.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);

    this.send(message);
  };

  handleNavigation = (path: string) => {
    const navigation = new Message(getName(MessageEnum.NavigationMessage));
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), path);
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(navigation);
  };

  handleShowFilterChange = () => {
    this.setState((prevState) => ({ showFilters: !prevState.showFilters }));
  };

  CustomUncheckedIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#94A3B8" />
    </svg>
  );

  CustomCheckedIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="6" fill="#652784" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.0611 5.42238C15.5183 5.73229 15.6376 6.35411 15.3277 6.81124L10.2432 14.3112C10.0771 14.5562 9.8111 14.715 9.51671 14.745C9.22232 14.7749 8.92977 14.673 8.71777 14.4665L4.80234 10.6536C4.40667 10.2683 4.39827 9.6352 4.78358 9.23953C5.16888 8.84386 5.80199 8.83546 6.19766 9.22077L9.25771 12.2007L13.6723 5.68895C13.9822 5.23182 14.604 5.11247 15.0611 5.42238Z"
        fill="white"
      />
    </svg>
  );

  handleSortChange = (label: string, value: string) => {
    this.setState(
      (prevState) => ({
        filterAndSortTags: [
          ...prevState.filterAndSortTags.filter((tag) => tag.type !== "Sort"),
          { type: "Sort", label, value },
        ],
        page: 0,
        randomSeed: null,
      }),
      () => this.handleGetUsersList()
    );
  };

  isEmptyValue = (value: string | string[]): boolean => {
    return (Array.isArray(value) && value.length === 0) || value === "";
  };

  updateOrAddItem = (
    existingFilters: IFilterAndSortTags[],
    newFilter: IFilterAndSortTags
  ): IFilterAndSortTags[] => {
    const index = existingFilters.findIndex(
      (item) => item.label === newFilter.label
    );

    if (index !== -1) {
      existingFilters[index].value = newFilter.value;
    } else {
      existingFilters.push(newFilter);
    }
    return [...existingFilters];
  };

  handleMultiDropdown = (
    existingFilters: IFilterAndSortTags[],
    filterInfo: IFilterAndSortTags
  ) => {
    const { value } = filterInfo;
    const isEmpty = this.isEmptyValue(value);
    if (isEmpty) {
      return [...existingFilters].filter(
        (filter) => filter.label !== filterInfo.label
      );
    }
    return this.updateOrAddItem(existingFilters, filterInfo);
  };

  handleFilterChange = (
    filterType: FilterTypes,
    value: string | string[],
    subLabel?: FilterTypes
  ) => {
    const logValue = Array.isArray(value) ? value.join(', ') : value
    logEvent('filter', { filter_name: filterType, value: logValue, subValue: subLabel })
    const { filterAndSortTags } = this.state;
    let updatedFilters = [...filterAndSortTags];
    let updatedFilter: IFilterAndSortTags = {
      type: "Filter",
      label: filterType,
      value,
    };
    const SINGLE_DROPDOWNS = [FilterTypes.Gender, FilterTypes.Location];
    const MULTI_DROPDOWNS = [FilterTypes.AgeRange, FilterTypes.LanguageSpoken];

    if (filterType === FilterTypes.Skills) {
      const existingFilterIndex = updatedFilters.findIndex(
        (filter) => filter.subLabel === subLabel
      );

      if (existingFilterIndex !== -1) {
        const existingFilter = updatedFilters[existingFilterIndex];

        if (existingFilter.value.includes(value as string)) {
          existingFilter.value = (existingFilter.value as string[]).filter(
            (item: string) => item !== value
          );

          if (existingFilter.value.length === 0) {
            updatedFilters.splice(existingFilterIndex, 1);
          }
        } else {
          existingFilter.value = [...existingFilter.value, value as string];
        }
      } else {
        updatedFilter = {
          ...updatedFilter,
          subLabel,
          value: [value as string],
        };
        updatedFilters.push(updatedFilter);
      }
    } else if (SINGLE_DROPDOWNS.includes(filterType)) {
      updatedFilters = this.updateOrAddItem(filterAndSortTags, updatedFilter);
    } else if (MULTI_DROPDOWNS.includes(filterType)) {
      updatedFilters = this.handleMultiDropdown(
        filterAndSortTags,
        updatedFilter
      );
    }
    this.setState(
      { filterAndSortTags: updatedFilters, page: 0, randomSeed: null },
      () => this.handleGetUsersList()
    );
  };

  handleRemoveTag = (tagToRemove: IFilterAndSortTags) => {
    this.setState(
      (prevState) => ({
        filterAndSortTags: prevState.filterAndSortTags.filter(
          (tag) => tag !== tagToRemove
        ),
        page: 0,
        randomSeed: null,
      }),
      () => this.handleGetUsersList()
    );
  };

  renderTagLabel = (tag: IFilterAndSortTags) => {
    const { type, label, value, subLabel } = tag;

    if (type === "Sort") {
      return (
        <>
          <strong>{type} - </strong> {label}
        </>
      );
    }

    const displayValue = Array.isArray(value)
      ? value.join(label === FilterTypes.AgeRange ? ", " : "-")
      : value;

    return (
      <>
        <strong>{subLabel || label} - </strong> {displayValue}
      </>
    );
  };

  handleClearAll = () => {
    this.setState({ filterAndSortTags: [], page: 0, randomSeed: null }, () =>
      this.handleGetUsersList()
    );
  };

  handleSearchPopupClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSearchUsers = () => {
    const { searchValue } = this.state;
    searchValue.length > 2 && this.getSearchUsersListApi(`name=${searchValue}`);
  };

  handleSearchValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (this.searchFieldRef.current && value.length > 2) {
      this.setState({
        searchValue: value,
        anchorEl: this.searchFieldRef.current,
        isSearching: true,
      });
    } else {
      this.setState({ searchValue: value, anchorEl: null, isSearching: false });
    }

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = window.setTimeout(() => {
      this.handleSearchUsers();
    }, 700);
  };
  // Customizable Area End
}
